<div class="alert alert-danger">
  An error occured while processing the request. <b>{{message}}</b>
</div>
